module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAC4AQMAAACo6KcpAAAAA1BMVEVhh6/cxCw4AAAAHklEQVRYw+3BMQEAAADCIPunNsReYAAAAAAAAAAkBx14AAGc+GVxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/协和万邦企业精神背景@2x.png
// module id = HZ4p
// module chunks = 0